module.exports = SPACEXR;